// <Breadcrumbs> — optional, 2+ levels deep only, per DESIGN.md §4.2.

import { Link } from "react-router-dom";
import "./Breadcrumbs.css";

export interface BreadcrumbItem {
  label: string;
  to?: string; // omit for the current leaf
}

export interface BreadcrumbsProps {
  items: readonly BreadcrumbItem[];
}

export function Breadcrumbs({ items }: BreadcrumbsProps): JSX.Element | null {
  if (items.length < 2) return null;
  return (
    <nav className="rb-breadcrumbs" aria-label="Breadcrumb">
      <ol>
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={`${item.label}-${i}`}>
              {item.to && !isLast ? (
                <Link to={item.to}>{item.label}</Link>
              ) : (
                <span aria-current={isLast ? "page" : undefined}>{item.label}</span>
              )}
              {!isLast && (
                <span className="rb-breadcrumbs__sep" aria-hidden="true">
                  /
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
